var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0v20H0V0h20zM7.244 4.513H3.35v.226l1.254 1.51a.52.52 0 0 1 .17.44v5.938a.683.683 0 0 1-.182.59l-1.412 1.712v.225h4.002v-.225l-1.41-1.712a.708.708 0 0 1-.195-.59V7.491l3.512 7.663h.408l3.017-7.663v6.144c0 .133-.008.167-.107.265l-1.085 1.054v.226h5.27v-.226l-1.048-1.029a.313.313 0 0 1-.12-.3V6.067a.313.313 0 0 1 .12-.301l1.072-1.028v-.226h-3.713l-2.647 6.603-3.01-6.603z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.a5fea278995734db1eec2ac3d56ecef7.svg";
export { ForwardRef as ReactComponent };